export default () => ({

    init() {

    }
});